import React from 'react';
import ProtectedRoute from './ProtectedRoute';

interface PosVendaRouteProps {
  children: React.ReactNode;
}

/** Pós-venda só abre para o papel Admin, a mesma tela de sem permissão das outras rotas. */
const PosVendaRoute: React.FC<PosVendaRouteProps> = ({ children }) => {
  return <ProtectedRoute requiredRoles={['Admin']}>{children}</ProtectedRoute>;
};

export default PosVendaRoute;
